import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Select } from "antd"
import { useForm } from "antd/es/form/Form";
import { FormInstance, FormProps } from "antd/lib";
import { useEffect, useRef } from "react";
import { icon_delelte } from "../../../../components/ExportImgFigma";
import { editColorCar, ICarColorEdit, ICodeCar } from "../../../../api/colorCar/colorCarApi";
import { ICarCompany, IRelative } from "../../../../api/selectOptions/selectOptionsApi";
import { fommatSelectOption } from "../../../../until";

interface ModalProp {
  isOpen: boolean
  inForCarColor?: ICarColorEdit
  sLCategoryCar: ICarCompany[]
  listGroupColor: IRelative[]

  onClose: () => void
  onSubmitFormModalEdit: (isSuccess: boolean, message?: string) => void
}

export const ModalEditColorCar: React.FC<ModalProp> = ({
  isOpen, inForCarColor, sLCategoryCar, listGroupColor,
  onClose, onSubmitFormModalEdit
}) => {
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };
  const onFinish: FormProps["onFinish"] = (values) => {
    const codeCar = values.colorcar.map((item: any) => ({
      title: item["namecolorcar"],
      titleDDMS: item["codecolorddms"],
      code: item["codecolorcar"]
    }))
    // confimSubmit(values.groupcolorcar, values.namebrand, codeCar, values.selectcolorcar)
    confimSubmit(values.namebrand, codeCar, values.selectcolorcar)

  };

  // const confimSubmit = async (title: string, categoryCarId: number, codeCar: ICodeCar[], groupColorId: number) => {
  //   const result = await editColorCar(Number(inForCarColor?.id), title, categoryCarId, codeCar, groupColorId)

  const confimSubmit = async (categoryCarId: number, codeCar: ICodeCar[], groupColorId: number) => {
    const result = await editColorCar(Number(inForCarColor?.id), categoryCarId, codeCar, groupColorId)

    if (result?.status) {
      onSubmitFormModalEdit?.(true, result?.message)
    } else {
      onSubmitFormModalEdit?.(false, result?.message)
    }
  }
  useEffect(() => {
    if (isOpen) {
      const formatCodeCar = inForCarColor?.codeCar.map((item) => ({
        "namecolorcar": item.title,
        "codecolorddms": item.titleDDMS,
        "codecolorcar": item.code
      }))
      form.setFieldsValue({
        // "groupcolorcar": inForCarColor?.title,
        "namebrand": inForCarColor?.categoryCarId,
        "colorcar": formatCodeCar,
        "selectcolorcar": inForCarColor?.groupColorId
      })
    }
  }, [isOpen])
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa màu xe</span>
          <CloseOutlined className="text-base text-8B8B8B" onClick={onClose} />
        </div>}
        open={isOpen}
        onCancel={onClose}
        centered
        className="w-modal-477 modal-content-update-group ant-modal-size"
        closeIcon={false}
        footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
          <span className="text-sm text-98A2B3 cursor-pointer" onClick={onClose}>Hủy</span>
          <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
            onClick={submitForm}>
            Lưu màu xe
          </button>
        </div>}
      >
        <div className="p-6 d-flex flex-column gap-18-px">
          <div className="d-flex flex-column gap-18-px">
            {/* <div className="d-flex flex-column gap-1">
              <Form.Item
                name="groupcolorcar"
                rules={[{ required: true, message: 'Nhập tên nhóm màu xe!' }]}
                className="m-none-form-item text-explan"
              >
                <Input
                  placeholder="Tên nhóm màu xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div> */}
            <div className="d-flex flex-column gap-1">
              <Form.Item
                name="namebrand"
                rules={[{ required: true, message: 'Chọn tên thương hiệu!' }]}
                className="m-none-form-item text-explan"
              >
                <Select
                  placeholder="Tên thương hiệu xe"
                  options={fommatSelectOption(sLCategoryCar)}
                  className="custome-select-t "

                />
              </Form.Item>
            </div>

            <div className="d-flex flex-column gap-3">
              <Form.List
                name="colorcar"
                initialValue={[{}]}
              >
                {(fields, { add, remove }) => (
                  <div className='d-flex flex-column gap-3'>
                    {fields.map((field, i) => (
                      <div key={field.key} className="d-flex gap-3">
                        {
                          fields.length > 1 &&
                          <img
                            src={icon_delelte}
                            alt=""
                            className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                            onClick={() => remove(i)}
                          />
                        }
                        <Form.Item
                          name={[field.name, 'namecolorcar']}
                          fieldKey={[i, "namecolorcar"]}
                          className="m-none-form-item text-explan"
                          rules={[
                            { required: true, message: 'Vui lòng nhập màu xe!' }
                          ]}
                        >
                          <Input
                            placeholder="Tên màu xe"
                            className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                          />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'codecolorddms']}
                          fieldKey={[i, "codecolorddms"]}
                          className="m-none-form-item text-explan"
                          rules={[
                            { required: true, message: 'Vui lòng nhập mã màu DDMS!' }
                          ]}
                        >
                          <Input
                            placeholder="Mã màu DDMS"
                            className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                          />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'codecolorcar']}
                          fieldKey={[i, "codecolorcar"]}
                          className="m-none-form-item text-explan"
                        >
                          <Input
                            placeholder="Mã màu xe"
                            className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                          />
                        </Form.Item>
                      </div>
                    ))}
                    <button
                      className='border-dashed-1890FF bg-white rounded-6-px  py-2 h-8 d-flex justify-center align-center gap-2 w-full'
                      onClick={add}
                    >
                      <PlusOutlined className='text-sm text-1890FF' />
                      <span className='text-sm fw-400 font-regular text-1890FF white-space-nowrap'>Thêm màu xe</span>
                    </button>
                  </div>
                )}
              </Form.List>
            </div>
            <div className="d-flex flex-column gap-1">
              <Form.Item
                name="selectcolorcar"
                // rules={[{ required: true, message: 'Chọn nhóm màu xe!' }]}
                className="m-none-form-item text-explan"
              >
                <Select
                  placeholder="Nhóm màu xe "
                  options={fommatSelectOption(listGroupColor)}
                  className="custome-select-t "

                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Modal>
    </Form>
  )
}
